import axios from "@/libs/api.request";

export const getRoleList = () => {
  return axios.request({
    url: "/rbac/getRoleList",
    csrf: false,
    method: "post"
  });
};
export const storeRole = (id, name) => {
  return axios.request({
    url: "/rbac/storeRole",
    data: { id, name },
    method: "post"
  });
};
export const removeRole = id => {
  return axios.request({
    url: "/rbac/removeRole",
    data: { id },
    method: "post"
  });
};

export const assignPermission = (id, permissions) => {
  return axios.request({
    url: "/rbac/assignPermission",
    data: { id, permissions },
    method: "post"
  });
};
